export default __webpack_public_path__ + "static/media/mixkit-arcade-retro-game-over-213.492ea39f.wav";